/* manual-personalizer.js (09/10) — áo "Thiết kế tay" (KHÔNG preview, KHÔNG engine podify).
 * Khách nhập Tên + Jahrgang + tick „Ich habe Name und Jahrgang auf Schreibfehler geprüft“. Designer nội bộ dựng file in.
 * Pattern ĐÃ CHỨNG MINH của r2-personalizer.js / podify3-v2shim.js:
 *  - ô ẩn properties[...] chèn VÀO TRONG mọi product-form form[action*='/cart/add'] của SP này (form chính + sticky), bỏ .installment;
 *    không dựa vào thuộc tính form= (khối custom liquid render form="" -> đơn #TL1383 mất _tpl).
 *  - chặn submit ở capture phase (document) TRƯỚC handler AJAX của theme; lớp phủ paygate trên khối mua; guard nút express.
 * Properties: Name (trim + gộp khoảng trắng), Jahrgang, _type=manual, _design, _case, _v, _yf (yy|yyyy, 09/10). KHÔNG BAO GIỜ _preview.
 * Tên khách = PII: không console.log, không đưa lên URL. Chỉ gửi beacon name-log (body) khi ATC hợp lệ.
 * Chạy lại an toàn: Minimog đổi product-info (sibling/combined) chèn lại script -> chỉ scan() root mới.
 * 23/10 (audit non-preview T6–T9):
 *  - T6: properties[Name] = tên ĐÃ áp case của design (applyCase) = đúng chữ khách thấy ở „So wird gedruckt:“ -> giỏ / checkout / designer cùng thấy;
 *        _raw = tên khách gõ (đã trim) để designer tra lại (vd ß -> SS khi case upper).
 *  - T7: ô tên cho gõ tới 40 ký tự (không cắt ngầm ở nameMax) -> quá nameMax thì hiện lỗi „Der Name darf höchstens … Zeichen lang sein“ ngay khi gõ.
 *  - T8: Jahrgang chỉ nhận 1900..năm hiện tại (tính bằng JS lúc chạy, không dùng Liquid now vì bị cache), câu lỗi giống r3-personalizer.js.
 *  - T9: Klaviyo „Added to Cart Full“ CHỈ sau khi /cart/add thành công (sự kiện 'product-ajax:added' của Minimog) qua emitter dùng chung assets/blz-atc-full.js.
 * 26/10 (np-bundle P0 — khối «Passend dazu», assets/np-bundle.js): API công khai thêm __pman.state() / props(cfg) / propsErr(cfg) / beacon() / repaint();
 *  ô ẩn form chính và dòng phụ của bundle dựng CHUNG bằng buildMap (cfg của TỪNG SP, chuẩn hoá giống manual-personalizer.liquid);
 *  update() phát sự kiện document 'pman:update'; chữ nút ✏️ sticky hỏi window.__npb.stickyTxt(ok) khi có tick phôi. Không tick gì -> hành vi y như cũ.
 */
(function () {
  "use strict";
  if (window.__pman && typeof window.__pman.scan === "function") { window.__pman.scan(); return; }

  var NAMELOG_EP = "https://blazora-portal.minhduc711qn.workers.dev/public/name-log";   // giống r2-personalizer.js (PREVIEW_EP -> /name-log)
  var LS_KEY = "pman_state";
  var PROPS = ["Name", "Jahrgang", "_type", "_design", "_case", "_v", "_yf", "_raw"];   // _yf (09/10): chụp yearFmt khách đã thấy; khoá "_" ẩn trong giỏ. _raw (23/10): tên khách gõ trước khi áp case
  var YEAR_RE = /^\d{4}$/;
  var YEAR_MIN = 1900;   // 23/10 T8: cận dưới Jahrgang; cận trên = năm hiện tại (yearMax)
  var NAME_HARD_MAX = 40;   // 23/10 T7: maxlength của ô tên — rộng hơn nameMax (≤ 30) để lỗi „höchstens … Zeichen“ hiện được thay vì cắt ngầm
  var PARTICLES = { von: 1, van: 1, de: 1, der: 1, zu: 1 };
  var MSG = {
    nameEmpty: "Bitte gib einen Namen ein",
    nameShort: "Der Name muss mindestens 2 Buchstaben haben",
    nameLong: function (n) { return "Der Name darf höchstens " + n + " Zeichen lang sein"; },
    nameDigits: "Bitte keine Zahlen im Namen – den Jahrgang trägst du im Feld darunter ein",
    nameChars: "Bitte nur lateinische Buchstaben (auch ä, ö, ü, ß, é …), Leerzeichen, Bindestrich (-) und Apostroph (') verwenden",
    year: "Bitte gib einen gültigen Jahrgang (4 Ziffern) ein",
    yearRange: function (a, b) { return "Bitte einen Jahrgang zwischen " + a + " und " + b + " eingeben"; },
    ok: "Bitte bestätige, dass Name und Jahrgang korrekt sind",
    nameLongFor: function (n) { return "Name zu lang für dieses Produkt (max. " + n + " Zeichen)"; },   /* 26/10 np-bundle: tên quá dài cho SP này (tối đa n ký tự) */
    noCfg: "Personalisierung für dieses Produkt nicht verfügbar",   /* 26/10 np-bundle: SP không có manual_config.id -> không cá nhân hoá được */
    stickyGo: " Jetzt personalisieren",
    stickyAdd: " In den Warenkorb"
  };

  // 09/10: chỉ chữ Latin (\p{Script=Latin}: äöüß, é, Đ, Ł …; chặn Кирилл/Ελλ/漢 — font designer là Latin) + dấu kết hợp (iOS/macOS có thể gõ dạng tách), khoảng trắng, gạch nối, nháy đơn (' ’ ‘ ʼ — iOS tự đổi ' thành ’).
  var NAME_OK, HAS_LETTER2;
  try {
    NAME_OK = new RegExp("^[\\p{Script=Latin}\\p{M} '\\u2019\\u2018\\u02BC\\-\\u2010]+$", "u");
    HAS_LETTER2 = new RegExp("\\p{L}[^\\p{L}]*\\p{L}", "u");
  } catch (e) {   // trình duyệt rất cũ không có \p{..}: Latin + Latin mở rộng
    NAME_OK = /^[A-Za-zÀ-ÖØ-öø-ɏḀ-ỿ̀-ͯ '’‘ʼ\-‐]+$/;
    HAS_LETTER2 = /[A-Za-zÀ-ÖØ-öø-ɏḀ-ỿ][^A-Za-zÀ-ÖØ-öø-ɏḀ-ỿ]*[A-Za-zÀ-ÖØ-öø-ɏḀ-ỿ]/;
  }

  function normName(s) {
    s = String(s == null ? "" : s);
    try { s = s.normalize("NFC"); } catch (e) { /* */ }
    return s.replace(/\s+/g, " ").trim();
  }
  function clen(s) { try { return Array.from(s).length; } catch (e) { return s.length; } }
  function up(s) { try { return s.toLocaleUpperCase("de-DE"); } catch (e) { return s.toUpperCase(); } }
  function low(s) { try { return s.toLocaleLowerCase("de-DE"); } catch (e) { return s.toLowerCase(); } }
  function applyCase(name, cs) {
    if (cs === "upper") return up(name);
    if (cs === "lower") return low(name);
    if (cs === "title") {
      return name.split(/([ \-‐])/).map(function (w) {
        if (!w || w === " " || w === "-" || w === "‐") return w;
        var a = Array.from ? Array.from(w) : w.split(""), rest = a.slice(1).join("");
        var mixed = rest !== up(rest) && rest !== low(rest);   // 09/10: giữ chữ hoa giữa từ khách gõ (McDonald, O'Brien)
        return up(a[0]) + (mixed ? rest : low(rest));
      }).join("");
    }
    return name;   // asis
  }
  function fmtYear(y, fmt) { return fmt === "yy" ? y.slice(2) : y; }
  function needsDesignHint(name) {
    if (!name) return false;
    if (/[ßẞ]/.test(name) || /[-‐]/.test(name)) return true;
    var toks = low(name).split(/[ \-‐]+/);
    for (var i = 0; i < toks.length; i++) if (PARTICLES[toks[i]]) return true;
    return false;
  }
  function nameError(n, max) {
    if (!n) return MSG.nameEmpty;
    if (/\d/.test(n)) return MSG.nameDigits;
    if (!NAME_OK.test(n)) return MSG.nameChars;
    if (clen(n) < 2 || !HAS_LETTER2.test(n)) return MSG.nameShort;
    if (clen(n) > max) return MSG.nameLong(max);
    return "";
  }
  function yearMax() { return new Date().getFullYear(); }
  function yearError(y) {
    if (!YEAR_RE.test(y)) return MSG.year;
    var n = parseInt(y, 10), mx = yearMax();
    return (n < YEAR_MIN || n > mx) ? MSG.yearRange(YEAR_MIN, mx) : "";
  }

  /* 26/10 (np-bundle P0): chuẩn hoá manual_config THÔ (metafield json của 1 SP bất kỳ, vd phôi anh em) GIỐNG HỆT snippets/manual-personalizer.liquid
     (nameMax: số, <4 -> 14, >30 -> 30; case: default 'upper' rồi chỉ nhận upper|lower|title|asis; yearFmt: chỉ 'yy' hoặc 'yyyy'; v: default '1').
     Trả {id, max, cs, yf, v} — cùng dạng với st.nc của root (init). */
  function normCfg(cfg) {
    cfg = cfg || {};
    var m = parseInt(cfg.nameMax, 10);
    if (isNaN(m) || m < 4) m = 14;
    if (m > 30) m = 30;
    var cs = /^(upper|lower|title|asis)$/.test(cfg["case"]) ? cfg["case"] : "upper";
    var v = (cfg.v == null || cfg.v === "" || cfg.v === false) ? "1" : String(cfg.v);
    return { id: cfg.id == null ? "" : String(cfg.id), max: m, cs: cs, yf: cfg.yearFmt === "yy" ? "yy" : "yyyy", v: v };
  }
  /* map line item properties (8 khoá PROPS) từ giá trị khách nhập v={n,y} + cfg đã chuẩn hoá c. syncHidden (form chính) và __pman.props (np-bundle) dùng CHUNG hàm này. */
  function buildMap(v, c) {
    return { Name: applyCase(v.n, c.cs), Jahrgang: v.y, _type: "manual", _design: c.id, _case: c.cs, _v: c.v, _yf: c.yf, _raw: v.n };
  }
  /* lý do không dựng được props cho cfg c ("" = được). own=true: cfg của chính root (câu lỗi như ô tên); own=false (phôi khác): tên hợp lệ nhưng
     dài hơn nameMax của phôi -> MSG.nameLongFor. Ô xác nhận chính tả KHÔNG xét ở đây (np-bundle gọi check(true) trước khi thêm). */
  function propsErr(v, c, own) {
    if (!c.id) return MSG.noCfg;
    var ne = nameError(v.n, c.max);
    if (ne && !own && clen(v.n) > c.max && !nameError(v.n, NAME_HARD_MAX)) return MSG.nameLongFor(c.max);
    return ne || yearError(v.y);
  }

  function lsGet() {
    try {
      var s = JSON.parse(localStorage.getItem(LS_KEY) || "null");
      if (s && (Date.now() - (s.t || 0)) < 7 * 864e5) return s;   // nhớ tối đa 7 ngày (như r2p_state)
    } catch (e) { /* */ }
    return null;
  }
  function lsSet(n, y) { try { localStorage.setItem(LS_KEY, JSON.stringify({ n: n, y: y, t: Date.now() })); } catch (e) { /* */ } }

  function isHidden(el) {   // Minimog viewTransition: node cũ display:none ~500ms trước khi bị gỡ
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) { if (n.style && n.style.display === "none") return true; }
    return false;
  }
  function inView(el) {
    try { var r = el.getBoundingClientRect(); return r.top >= 50 && r.bottom <= (window.innerHeight - 130); } catch (e) { return false; }
  }
  function flash(el) { if (!el) return; el.classList.remove("pman-flash"); void el.offsetWidth; el.classList.add("pman-flash"); }

  var ROOTS = [];
  function activeRoot(pid) {
    for (var i = ROOTS.length - 1; i >= 0; i--) {
      var r = ROOTS[i];
      if (!document.documentElement.contains(r)) { ROOTS.splice(i, 1); continue; }
      if (pid != null && String(r.__pman.cfg.pid) !== String(pid)) continue;
      if (!isHidden(r)) return r;
    }
    return null;
  }
  function formPid(f) { return f ? String(f.getAttribute("data-product-id") || "") : ""; }
  function isCartForm(f) { return !!(f && f.tagName === "FORM" && String(f.getAttribute("action") || "").indexOf("/cart/add") >= 0); }

  function init(root) {
    if (root.__pman) return;
    var cfg;
    try { cfg = JSON.parse(root.querySelector("[data-pman-config]").textContent); } catch (e) { return; }
    if (!cfg || !cfg.id) return;
    var max = parseInt(cfg.nameMax, 10); if (!(max >= 4 && max <= 30)) max = 14;
    var CASE = /^(upper|lower|title|asis)$/.test(cfg["case"]) ? cfg["case"] : "upper";
    var YFMT = cfg.yearFmt === "yy" ? "yy" : "yyyy";
    var YDEF = YEAR_RE.test(String(cfg.yearDefault || "")) ? String(cfg.yearDefault) : "";   // 10/10: trống = không điền sẵn, khách tự nhập (ô bắt buộc)
    var PID = String(cfg.pid || root.getAttribute("data-product-id") || "");

    var nameIn = root.querySelector("[data-pman-name]");
    var yearIn = root.querySelector("[data-pman-year]");
    var okIn = root.querySelector("[data-pman-ok]");
    var sumBox = root.querySelector("[data-pman-sum]");
    var sumV = root.querySelector("[data-pman-sum-v]");
    var hint = root.querySelector("[data-pman-hint]");
    var errEl = { name: root.querySelector('[data-pman-err="name"]'), year: root.querySelector('[data-pman-err="year"]'), ok: root.querySelector('[data-pman-err="ok"]') };
    var fieldEl = { name: root.querySelector('[data-pman-f="name"]'), year: root.querySelector('[data-pman-f="year"]'), ok: root.querySelector('[data-pman-f="ok"]') };
    var inputEl = { name: nameIn, year: yearIn, ok: okIn };
    if (!nameIn || !yearIn || !okIn) return;
    nameIn.maxLength = NAME_HARD_MAX;   // 23/10 T7: không cắt ở max -> nameError báo „höchstens max Zeichen“
    if (!YEAR_RE.test(yearIn.value || "")) yearIn.value = YDEF;

    var st = { cfg: cfg, touched: { name: false, year: false }, shown: false };
    st.nc = { id: String(cfg.id), max: max, cs: CASE, yf: YFMT, v: String(cfg.v == null ? "1" : cfg.v) };   /* 26/10: cfg đã chuẩn hoá của root — buildMap / __pman.props() */
    root.__pman = st;
    ROOTS.push(root);

    // khôi phục giá trị khi khách chuyển SP anh em (Minimog thay product-info / điều hướng). Ô xác nhận KHÔNG khôi phục.
    var sv = lsGet();
    if (sv) {
      if (sv.n && !nameIn.value) nameIn.value = String(sv.n).slice(0, NAME_HARD_MAX);   // 23/10 T7: không cắt ở max (tên dài -> hiện lỗi)
      if (sv.y && YEAR_RE.test(String(sv.y))) yearIn.value = String(sv.y);
    }

    function vals() { return { n: normName(nameIn.value), y: String(yearIn.value || "").trim(), ok: !!okIn.checked }; }
    function errors() {
      var v = vals();
      return { name: nameError(v.n, max), year: yearError(v.y), ok: v.ok ? "" : MSG.ok };
    }
    function valid() { var e = errors(); return !e.name && !e.year && !e.ok; }
    function setErr(k, msg) {
      var el = errEl[k], inp = inputEl[k];
      if (el) { el.textContent = msg || ""; el.hidden = !msg; }
      if (inp) { if (msg) inp.setAttribute("aria-invalid", "true"); else inp.removeAttribute("aria-invalid"); }
      if (fieldEl[k]) fieldEl[k].classList.toggle("pman__field--bad", !!msg);
    }
    // hiện lỗi: sau lần bấm mua đầu tiên (shown) -> mọi lỗi; trước đó chỉ lỗi định dạng của ô đã rời (không báo "trống" khi khách chưa gõ)
    function paintErrors(all) {
      var e = errors(), v = vals();
      if (all || st.shown) { setErr("name", e.name); setErr("year", e.year); setErr("ok", e.ok); return e; }
      setErr("name", (st.touched.name && v.n) || clen(v.n) > max ? e.name : "");   // 23/10 T7: quá dài -> báo ngay khi gõ
      setErr("year", st.touched.year || v.y.length === 4 ? e.year : "");   // 23/10 T8: đủ 4 số mà ngoài 1900..năm nay -> báo ngay
      setErr("ok", "");
      return e;
    }

    // ===== ô ẩn properties[...] VÀO TRONG form /cart/add của SP này (form chính + sticky), bỏ .installment =====
    function cartForms() {
      var fs = [].slice.call(document.querySelectorAll("product-form form[action*='/cart/add']"));
      if (!fs.length) fs = [].slice.call(document.querySelectorAll("form[action*='/cart/add']"));
      return fs.filter(function (f) {
        if (f.classList.contains("installment")) return false;
        var p = formPid(f);
        return !p || p === PID;
      });
    }
    function putIn(f, key, val) {
      var el = f.querySelector('input[data-pman-prop="' + key + '"]');
      if (!el) {
        el = document.createElement("input");
        el.type = "hidden"; el.name = "properties[" + key + "]";
        el.setAttribute("data-pman-prop", key);
        f.appendChild(el);
      }
      if (el.value !== val) el.value = val;
    }
    function syncHidden(extra) {
      var v = vals();
      // 23/10 T6: Name = bản ĐÃ áp case (đúng chữ ở „So wird gedruckt:“); _raw = chữ khách gõ
      // 26/10: dựng bằng buildMap(v, st.nc) — CHUNG với __pman.props() của np-bundle (giá trị y như trước)
      var map = buildMap(v, st.nc);
      var fs = cartForms();
      if (extra && fs.indexOf(extra) < 0) fs.push(extra);   // form đang submit luôn mang đủ khoá
      fs.forEach(function (f) { PROPS.forEach(function (k) { putIn(f, k, map[k]); }); });
    }

    function paintSummary() {
      var v = vals(), e = errors();
      if (v.n && !e.name) {
        sumV.textContent = applyCase(v.n, CASE) + " · " + (e.year ? "—" : fmtYear(v.y, YFMT));
        sumBox.hidden = false;
      } else { sumV.textContent = ""; sumBox.hidden = true; }
      if (hint) hint.hidden = !needsDesignHint(v.n);
    }

    // ===== cổng: lớp phủ khối mua + guard nút express (cùng điều kiện hợp lệ) =====
    var pi = root.closest("product-info") || document;
    var buy = pi.querySelector(".m-main-product--info .main-product__block-buy_buttons") || pi.querySelector(".main-product__block-buy_buttons") || document.querySelector(".m-main-product--info .main-product__block-buy_buttons");
    var gate = null;
    if (buy && !buy.querySelector(".pman-paygate")) {
      gate = document.createElement("div");
      gate.className = "pman-paygate";
      gate.setAttribute("aria-hidden", "true");
      buy.classList.add("pman-buy");
      buy.appendChild(gate);
      gate.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); block(); }, true);
    }
    var dynWraps = [].slice.call(pi.querySelectorAll(".m-product-dynamic-checkout, .buy-one-click"));
    dynWraps.forEach(function (w) {
      if (w.__pmanGuard) return;
      w.classList.add("pman-dynwrap");
      var g = document.createElement("div");
      g.className = "pman-express-guard";
      g.setAttribute("aria-hidden", "true");
      g.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); block(); });
      w.appendChild(g);
      w.__pmanGuard = g;
    });
    function paintGates(ok) {
      if (gate) gate.hidden = ok;
      dynWraps.forEach(function (w) { if (w.__pmanGuard) w.__pmanGuard.hidden = ok; });
      var t = document.querySelectorAll("[data-sticky-manual-txt]");
      var s = ok ? MSG.stickyAdd : MSG.stickyGo;
      // 26/10 np-bundle: có tick phôi đi kèm -> chữ sticky do np-bundle quyết (vd „Set (2) in den Warenkorb“); "" = giữ chữ mặc định
      var nb = window.__npb;
      if (nb && typeof nb.stickyTxt === "function") { try { var o = nb.stickyTxt(ok); if (o) s = o; } catch (x) { /* */ } }
      for (var i = 0; i < t.length; i++) { if (t[i].textContent !== s) t[i].textContent = s; }
      var sb = document.querySelectorAll("[data-sticky-manual]");   // desktop: đủ dữ liệu -> ẩn ✏️, chừa nút ATC sticky (CSS)
      for (var j = 0; j < sb.length; j++) sb[j].classList.toggle("pman-sticky-ok", ok);
    }

    // chặn: hiện mọi lỗi, cuộn + focus ô lỗi ĐẦU TIÊN
    function block() {
      st.shown = true;
      var e = paintErrors(true);
      var k = e.name ? "name" : (e.year ? "year" : (e.ok ? "ok" : null));
      if (!k) return;
      var fld = fieldEl[k] || root, inp = inputEl[k];
      var vis = inView(fld);
      if (!vis) { try { fld.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (x) { /* */ } }
      flash(fld);
      setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (x) { try { inp.focus(); } catch (y) { /* */ } } }, vis ? 0 : 420);
    }

    var lastOk = null;
    function update() {
      syncHidden();
      paintSummary();
      paintErrors(false);
      var ok = valid();
      if (ok !== lastOk) { lastOk = ok; paintGates(ok); }
      try { document.dispatchEvent(new CustomEvent("pman:update", { detail: { pid: PID } })); } catch (x) { /* 26/10: np-bundle vẽ lại chữ „Gedruckt“ / khoá dòng */ }
    }

    function onNameInput() {
      if (okIn.checked && st._lastN !== undefined && st._lastN !== normName(nameIn.value)) okIn.checked = false;   // đổi tên sau khi đã xác nhận -> xác nhận lại
      st._lastN = normName(nameIn.value);
      lsSet(nameIn.value, yearIn.value);
      update();
    }
    function onYearInput() {
      var d = String(yearIn.value || "").replace(/\D+/g, "").slice(0, 4);
      if (d !== yearIn.value) yearIn.value = d;
      if (okIn.checked && st._lastY !== undefined && st._lastY !== d) okIn.checked = false;
      st._lastY = d;
      lsSet(nameIn.value, yearIn.value);
      update();
    }
    st._lastN = normName(nameIn.value); st._lastY = String(yearIn.value || "");
    nameIn.addEventListener("input", onNameInput);
    yearIn.addEventListener("input", onYearInput);
    nameIn.addEventListener("blur", function () {
      var n = normName(nameIn.value);
      if (n !== nameIn.value) { nameIn.value = n; }   // trim + gộp khoảng trắng ngay trong ô (đúng giá trị sẽ in)
      st.touched.name = true; update();
    });
    yearIn.addEventListener("blur", function () { st.touched.year = true; update(); });
    okIn.addEventListener("change", update);
    nameIn.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); try { yearIn.focus(); } catch (x) { /* */ } } });
    yearIn.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); try { okIn.focus(); } catch (x) { /* */ } } });

    st.syncHidden = syncHidden;
    st.update = update;
    st.valid = valid;
    st.block = block;
    st.vals = vals;
    st.errors = errors;
    st.repaint = function () { lastOk = valid(); paintGates(lastOk); };   /* 26/10: np-bundle đổi số món tick -> vẽ lại chữ / lớp nút sticky */
    update();
    document.documentElement.classList.add("pman-ready");   // mở khoá nút mua (CSS khoá khi JS chưa chạy)
    if (sv && sv.n) { st.touched.name = true; update(); }
  }

  // ===== submit guard (capture, document) — chạy TRƯỚC handler AJAX của Minimog product-form =====
  var lastBeacon = 0;
  function beacon(st) {
    try {
      if (Date.now() - lastBeacon < 1500) return;
      lastBeacon = Date.now();
      var v = st.vals();
      var body = JSON.stringify({ e: "atc", n: v.n.slice(0, 40), f: "manual", l: String(st.cfg.id), b: v.y });
      if (navigator.sendBeacon) navigator.sendBeacon(NAMELOG_EP, new Blob([body], { type: "text/plain" }));
      else if (window.fetch) fetch(NAMELOG_EP, { method: "POST", body: body, keepalive: true, headers: { "content-type": "text/plain" } }).catch(function () { /* */ });
    } catch (e) { /* im lặng */ }
  }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!isCartForm(f) || f.classList.contains("installment")) return;
    var p = formPid(f);
    if (!p && !(f.closest && f.closest("product-form"))) return;   // form /cart/add lạ (app khác, SP khác) -> không đụng
    var root = activeRoot(p || null);
    if (!root) return;
    var st = root.__pman;
    st.syncHidden(f);
    if (!st.valid()) {
      e.preventDefault(); e.stopImmediatePropagation();
      st.block();
      return;
    }
    beacon(st);
  }, true);
  // 23/10 T9: Klaviyo „Added to Cart Full“ — CHỈ khi /cart/add THÀNH CÔNG: Minimog product-form (form chính + sticky) bắn 'product-ajax:added'
  // với detail.product = dòng vừa thêm; add lỗi -> 'product-ajax:error', không có sự kiện này. Chỉ dòng _type=manual; emitter + chặn trùng 1,5 s ở blz-atc-full.js.
  document.addEventListener("product-ajax:added", function (e) {
    try {
      var d = e && e.detail && e.detail.product;
      if (!d) return;
      var arr = (d.items && d.items.length) ? d.items : [d];
      for (var i = 0; i < arr.length; i++) {
        var p = (arr[i] && arr[i].properties) || {};
        if (p._type === "manual") {
          if (window.BlzAtcFull && typeof window.BlzAtcFull.fire === "function") window.BlzAtcFull.fire("manual");
          return;
        }
      }
    } catch (x) { /* im lặng */ }
  });
  // mua nhanh (Shopify payment button) không đi qua submit
  document.addEventListener("click", function (e) {
    var x = e.target && e.target.closest ? e.target.closest(".shopify-payment-button,.m-product-dynamic-checkout,shopify-buy-it-now-button,shopify-accelerated-checkout") : null;
    if (!x) return;
    var f = x.closest("form");
    var root = activeRoot(f ? (formPid(f) || null) : null);
    if (!root) return;
    var st = root.__pman;
    st.syncHidden();
    if (!st.valid()) { e.preventDefault(); e.stopImmediatePropagation(); st.block(); }
  }, true);

  function scan() {
    var rs = document.querySelectorAll("[data-pman]");
    for (var i = 0; i < rs.length; i++) { try { init(rs[i]); } catch (e) { /* một root lỗi không chặn root khác */ } }
    for (var j = 0; j < ROOTS.length; j++) { try { ROOTS[j].__pman.syncHidden(); } catch (e) { /* */ } }
  }

  // API cho nút ✏️ sticky (sticky-atc.liquid): check(true) = hợp lệ? nếu không -> cuộn + hiện lỗi
  // 26/10 (np-bundle P0, assets/np-bundle.js): thêm state / props / propsErr / beacon / repaint — scan, check giữ nguyên hành vi.
  window.__pman = {
    scan: scan,
    check: function (show) {
      var r = activeRoot(null);
      if (!r) return false;
      var st = r.__pman;
      st.syncHidden();
      if (st.valid()) return true;
      if (show) st.block();
      return false;
    },
    // state() -> {name, year, ok, confirmed, nameErr, yearErr, pid} của root đang hiện; ok = tên + năm hợp lệ + đã tick xác nhận (CÙNG luật cổng submit). Không có root -> null
    state: function () {
      var r = activeRoot(null);
      if (!r) return null;
      var st = r.__pman, v = st.vals(), e = st.errors();
      return { name: v.n, year: v.y, ok: !e.name && !e.year && !e.ok, confirmed: v.ok, nameErr: e.name, yearErr: e.year, pid: String(st.cfg.pid || "") };
    },
    // props(cfg, out) -> object line item properties (8 khoá như ô ẩn form chính) cho 1 SP non-preview theo manual_config THÔ cfg của chính SP đó;
    // bỏ trống cfg = cfg của root (= đúng ô ẩn form chính). Tên/năm không hợp lệ cho cfg (vd tên dài hơn cfg.nameMax) -> null, out.err = lý do.
    props: function (cfg, out) {
      var r = activeRoot(null);
      if (!r) { if (out) out.err = MSG.noCfg; return null; }
      var st = r.__pman, v = st.vals(), own = !cfg, c = own ? st.nc : normCfg(cfg);
      var err = propsErr(v, c, own);
      if (out) out.err = err;
      return err ? null : buildMap(v, c);
    },
    // propsErr(cfg) -> "" nếu props(cfg) dựng được, ngược lại câu lý do (tiếng Đức, hiện cho khách)
    propsErr: function (cfg) {
      var r = activeRoot(null);
      if (!r) return MSG.noCfg;
      var st = r.__pman;
      return propsErr(st.vals(), cfg ? normCfg(cfg) : st.nc, !cfg);
    },
    // beacon() -> name-log (như khi submit form hợp lệ; chặn trùng 1,5 s) — np-bundle gọi sau khi thêm set qua fetch
    beacon: function () { var r = activeRoot(null); if (r) beacon(r.__pman); },
    // repaint() -> vẽ lại chữ + lớp nút ✏️ sticky (paintGates hỏi window.__npb.stickyTxt)
    repaint: function () { var r = activeRoot(null); if (r && r.__pman.repaint) r.__pman.repaint(); }
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan); else scan();
  // Minimog thay product-info (combined listing / swap): root mới -> init; form mới -> chèn lại ô ẩn
  if ("MutationObserver" in window) {
    var tmr = 0;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var a = ms[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType === 1 && ((n.matches && n.matches("[data-pman],form")) || (n.querySelector && n.querySelector("[data-pman],form[action*='/cart/add']")))) {
            clearTimeout(tmr); tmr = setTimeout(scan, 30); return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
